import { render, staticRenderFns } from "./Vakken.vue?vue&type=template&id=10bb1000&scoped=true&"
import script from "./Vakken.vue?vue&type=script&lang=js&"
export * from "./Vakken.vue?vue&type=script&lang=js&"
import style0 from "./Vakken.vue?vue&type=style&index=0&id=10bb1000&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bb1000",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VContainer,VProgressCircular})
